const shoutouts = (state = [], action) => {
  const { payload, type } = action;

  let idsList = [];
  switch (type) {
    case 'INITIAL_DATA':
      return state?.length ? [...state] : [];

    case 'SET_SHOUTOUTS':
      return payload;

    case 'ADD_SHOUTOUTS':
      idsList = payload.map((x) => x?._id);

      return [...payload, ...state.filter((x) => !idsList.includes(x._id))];

    case 'UPDATE_SHOUTOUT':
      return state.map((shoutout) => {
        if (shoutout._id !== payload._id) return shoutout;

        return {
          ...shoutout,
          ...payload
        };
      });

    case 'ADD_SHOUTOUT':
      return [payload, ...state.filter((x) => payload._id !== x._id)];

    case 'NEW_NOTIFICATION':
      if (!payload.shoutout) return state;

      return [payload.shoutout, ...state];

    case 'ADD_REACTION_TO_SHOUTOUT':
      const { prevReaction, entityId, reaction } = payload;

      return state.map((x) => {
        if (x._id !== entityId) return x;

        let newReactions = {};

        if (prevReaction && prevReaction === reaction) {
          newReactions = {
            [prevReaction]: x.reactionCounts[prevReaction] - 1
          };
        }

        if (prevReaction && prevReaction !== reaction) {
          newReactions = {
            [prevReaction]: (x.reactionCounts?.[prevReaction] ?? 0) - 1,
            [reaction]: (x.reactionCounts?.[reaction] ?? 0) + 1
          };
        }

        if (!prevReaction) {
          newReactions = {
            [reaction]: (x.reactionCounts?.[reaction] ?? 0) + 1
          };
        }

        return {
          ...x,
          reactionCounts: {
            ...x.reactionCounts,
            ...newReactions
          },
          reactionCount: (x.reactionCount || 0) + 1
        };
      });

    default:
      return state;
  }
};

export default shoutouts;
